
interface BlogPost {
  title: string;
  content: string;
  image: string;
}

export const validateBlogData = (data: any): BlogPost | null => {
  if (!data || typeof data !== 'object') {
    return null;
  }

  if (
    typeof data.title !== 'string' ||
    typeof data.content !== 'string' ||
    typeof data.image !== 'string'
  ) {
    return null;
  }

  return {
    title: data.title,
    content: data.content,
    image: data.image
  };
};
